import React from "react";
import styled from "styled-components";

export default styled.div`
    font-family: 'Effra', sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #4E99D6;
    
    i {
        margin-right: 20px;
    }
`;